import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "moduleId", "aliasGroupId"]

  open(event) {
    if (!this.hasDialogTarget) {
      return
    }

    const trigger = event?.currentTarget
    const moduleId = trigger?.dataset?.moduleId
    const rawGroupId = trigger?.dataset?.aliasGroupId
    const aliasGroupId = rawGroupId && rawGroupId !== "null" && rawGroupId !== "undefined" ? rawGroupId : ""

    const form = this.dialogTarget.querySelector("form")
    if (form) {
      form.reset()
    }

    const builderEl = this.dialogTarget.querySelector("[data-controller~='pair-expression-builder']")
    if (builderEl) {
      this.application
        .getControllerForElementAndIdentifier(builderEl, "pair-expression-builder")
        ?.reset()
    }

    if (this.hasModuleIdTarget && moduleId) {
      this.moduleIdTarget.value = moduleId
    }

    if (this.hasAliasGroupIdTarget) {
      this.aliasGroupIdTarget.value = aliasGroupId
    }

    this.showDialog()
  }

  close() {
    if (!this.hasDialogTarget) {
      return
    }

    if (this.dialogTarget.close) {
      this.dialogTarget.close()
    } else {
      this.dialogTarget.removeAttribute("open")
    }
  }

  showDialog() {
    if (this.dialogTarget.showModal) {
      this.dialogTarget.showModal()
    } else {
      this.dialogTarget.setAttribute("open", "open")
    }
  }
}
